import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { AnnouncementResponse } from "api/announcement/type";
import { ResponseCode } from "contants/response";
import { NoInfer } from "react-redux";
import { AnnouncementType } from "types/announcement";

import { getAnnouncement } from "./announcement.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<AnnouncementType>>
) => {
  builder
    .addCase(getAnnouncement.pending, (state: AnnouncementType) => {
      state.isLoading = true;
    })
    .addCase(
      getAnnouncement.fulfilled,
      (
        state: AnnouncementType,
        action: PayloadAction<AnnouncementResponse>
      ) => {
        if (!action.payload || action.payload.status !== ResponseCode.SUCCESS) {
          state.isLoading = false;
          return;
        }
        state.isLoading = false;

        const dataRes = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        const currentPage = action.payload.currentPage || 1;
        state.currentPage = currentPage;

        if (action.payload.type === 1) {
          return;
        }
        state.data =
          currentPage > 1 ? [...(state.data || []), ...dataRes] : dataRes;
        state.totalCount = action.payload.totalCount || dataRes.length;
        state.totalPages = action.payload.totalPages || 1;
        state.pageSize = action.payload.pageSize || 10;
      }
    )
    .addCase(getAnnouncement.rejected, (state: AnnouncementType) => {
      state.isLoading = false;
    });
};
